import { usePaginationContext } from '../pagination-context';

import type { ReactElement } from 'react';

const PaginationSummary = (): ReactElement => {
  const paginationContext = usePaginationContext();

  if (!paginationContext) {
    throw new Error('PaginationSummary must be used within a PaginationContext.Provider');
  }

  const { count, itemsPerPage, page } = paginationContext;
  const start = page * itemsPerPage + 1;
  const end = Math.min((page + 1) * itemsPerPage, count);

  return (
    <div className="rbui-pagination__summary">
      Showing {start.toLocaleString()} {start !== end ? <>to {end.toLocaleString()} </> : null}
      of {count.toLocaleString()}
    </div>
  );
};

PaginationSummary.displayName = 'PaginationSummary';

export { PaginationSummary };
